import styled from '@emotion/styled'

export const StyleTalkToSupportWrapper = styled.div`
  background-color: #f5f3ff;
  width: full;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 8px 20px;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 10px;
  }
`

export const StyleTalkToSupportRightContentWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  height: auto;
  @media (max-width: 768px) {
    flex-direction: column;
    row-gap: 10px;
  }
`
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
